/* Iron & Oak — cart drawer tweaks that survive Shopify's snippet cache.
   - Inserts a middle-dot between "Buy more" and "Save more"
   - Hides the shipping progress bar (defensive; CSS also handles it) */
(function () {
  'use strict';

  function tweakHeading() {
    var headings = document.querySelectorAll('.drawer__heading');
    headings.forEach(function (h) {
      var text = h.textContent.trim();
      if (/Buy\s*more\s+Save\s*more/i.test(text) && text.indexOf('·') === -1) {
        h.innerHTML = h.innerHTML.replace(
          /(Buy\s*more)(\s+)(Save\s*more)/i,
          '$1&nbsp;&middot;&nbsp;$3'
        );
      }
    });
  }

  function hideShippingProgress() {
    document.querySelectorAll('.ec-cartx3-ship, .ec-cartx3-ship__track, .ec-cartx3-ship__msg').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  // Highlights the tier that matches the current cart quantity.
  // - 4+ items → last tier
  // - 3 items → middle tier
  // - 2 items → first tier
  // - <2 items → none active
  function updateTierLadder(qty) {
    var ladders = document.querySelectorAll('.cart-tier-ladder');
    if (!ladders.length) return;
    ladders.forEach(function (ladder) {
      var tiers = ladder.querySelectorAll('.cart-tier-ladder__tier');
      var activeMin = 0;
      if (qty >= 4) activeMin = 4;
      else if (qty >= 3) activeMin = 3;
      else if (qty >= 2) activeMin = 2;
      tiers.forEach(function (tier) {
        var min = parseInt(tier.getAttribute('data-tier-min') || '0', 10);
        if (min === activeMin) tier.classList.add('is-active');
        else tier.classList.remove('is-active');
      });
      ladder.setAttribute('data-cart-qty', qty);
    });
  }

  function fetchAndUpdateTier() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) updateTierLadder(cart.item_count); })
      .catch(function () {});
  }

  function run() {
    tweakHeading();
    hideShippingProgress();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  // Re-run whenever the drawer's HTML is refreshed by Shopify's Section Rendering API
  var observer = new MutationObserver(function () { run(); });
  observer.observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', run);

  // Update the tier ladder whenever the cart data changes.
  // Dawn's cart-drawer fires a custom event; we also hook add-to-cart forms.
  document.addEventListener('cart:updated', fetchAndUpdateTier);
  document.addEventListener('cart:refresh', fetchAndUpdateTier);
  document.addEventListener('shopify:cart:update', fetchAndUpdateTier);

  // Intercept the Shopify Ajax API POST /cart/add.js and /cart/change.js.
  // When either resolves, refetch cart and update ladder.
  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      var promise = origFetch.apply(this, args);
      if (/\/cart\/(add|change|update|clear)(\.js|\?|$)/.test(url)) {
        promise.then(function () { setTimeout(fetchAndUpdateTier, 30); });
      }
      return promise;
    };
  }

  // Initial sync in case Liquid rendered a stale count
  fetchAndUpdateTier();
})();
